<template>
  <page-outline 
    :title="$t('Webheader.connector_list_'+entitiesType+'_'+role+'_'+type)"
    :show-refresh="true"
    :refresh-disabled="activateSpinner"
    @refresh="onRefresh">
    
    <!-- Actions principales -->
    <template v-slot:primaryActions>
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        :returnUrl="returnUrl"
        :isBackButton="true"
        :aria-label="$t('common.bck')"
      />
    </template>
    
    <template slot="pageContent">
      <b-container fluid class="listPage">

        <b-row class="justify-content-start">
          <b-col cols="6" lg="3" xl="3" v-if="canGetVopProvider && entitiesType == 'rvm'">
            <app-button
              :text="$t('common.routing.consult_list_vop_provider')"
              variant="primary"
              :block="true"
              custom-class="mr-3 justify-item-end responsive-button"
              @click="getVopProvider">
            </app-button>
          </b-col>
        </b-row>

        <br />
        <b-tabs :value="role == 0 ? 1 : 0" nav-class="d-none">
          <!-- Credential LIST -->
          <b-tab :class="role == 0 ? 'd-none': ''" :title="$t('common.routing.receiver')">
            <b-row>
              <b-tabs v-model="tabIndex" class="p-3 w-100" content-class="mt-3">
                <b-tab title="WebService"><b-col md="12">
                  <spinner v-if="activateSpinner"></spinner>
                  <div v-else>
                    <b-table hover responsive
                      v-if="webServiceCredentialList.length > 0"
                      class="mt-3 table-striped"
                      :items="webServiceCredentialList"
                      :fields="webServiceCredentialFields"
                      selectable select-mode="single" @row-selected="seeWebServiceCredentialDetails">
                      <template #cell(Active)="data">
                        {{data.value === '1' ? $t('common.routing.yes') : $t('common.routing.no')}}
                      </template>
                    </b-table>
                    <div v-else class="d-flex justify-content-center">
                      <span class="noResult">
                        {{ $t('common.no_result') }}
                      </span>
                    </div>
                  </div>
                </b-col>
                </b-tab>
                <b-tab title="MqSeries">
                  <b-col md="12">
                    <spinner v-if="activateSpinner"></spinner>
                    <div v-else>
                      <b-table hover responsive
                        v-if="mqseriesCredentialList.length > 0"
                        class="mt-3 table-striped"
                        :items="mqseriesCredentialList"
                        :fields="mqseriesCredentialFields"
                        selectable select-mode="single" @row-selected="seeMQSeriesCredentialDetails">
                        <template #cell(Active)="data">
                          {{data.value === '1' ? $t('common.routing.yes') : $t('common.routing.no')}}
                        </template>
                        <template #cell(idEngine)="data">
                          {{$engine.get(data.value).common.network.info.name}}
                        </template>
                      </b-table>

                      <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-tab>
                <b-tab :title="$t('common.routing.ftp')">
                  <b-col md="12">
                    <spinner v-if="activateSpinner"></spinner>
                    <div v-else>
                      <b-table hover responsive
                        v-if="FTPCredentialList.length > 0"
                        class="mt-3 table-striped"
                        :items="FTPCredentialList"
                        :fields="FTPFields"
                        selectable select-mode="single" @row-selected="seeFTPCredentialDetails">
                      </b-table>

                      <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-tab>
              </b-tabs>
            </b-row>
          </b-tab>
          <!-- Config LIST -->
          <b-tab :class="role == 1 ? 'd-none': ''" :title="$t('common.routing.responder')">
            <b-row>
              <b-tabs v-model="tabIndex" class="p-3 w-100" content-class="mt-3">
                <b-tab title="WebService"><b-col md="12">
                  <spinner v-if="activateSpinner"></spinner>
                  <div v-else>
                    <b-table hover responsive
                      v-if="webServiceConfigList.length > 0"
                      class="mt-3 table-striped"
                      :items="webServiceConfigList"
                      :fields="webServiceConfigFields"
                      selectable select-mode="single" @row-selected="seeWebServiceConfigDetails">
                      <template #cell(Active)="data">
                        {{data.value === '1' ? $t('common.routing.yes') : $t('common.routing.no')}}
                      </template>
                    </b-table>

                    <div v-else class="d-flex justify-content-center">
                      <span class="noResult">
                        {{ $t('common.no_result') }}
                      </span>
                    </div>
                  </div>
                </b-col>
                </b-tab>
                <b-tab title="MqSeries">
                  <b-col md="12">
                    <spinner v-if="activateSpinner"></spinner>
                    <div v-else>
                      <b-table hover responsive
                        v-if="mqseriesConfigList.length > 0"
                        class="mt-3 table-striped table-hover"
                        :items="mqseriesConfigList"
                        :fields="mqseriesFields"
                        selectable select-mode="single" @row-selected="seeMQSeriesDetails">
                        <template #cell(Active)="data">
                          {{data.value === '1' ? $t('common.routing.yes') : $t('common.routing.no')}}
                        </template>
                        <template #cell(idEngine)="data">
                          {{$engine.get(data.value).common.network.info.name}}
                        </template>
                      </b-table>

                      <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-tab>
                <b-tab :title="$t('common.routing.ftp')">
                  <b-col md="12">
                    <spinner v-if="activateSpinner"></spinner>
                    <div v-else>
                      <b-table hover responsive
                        v-if="FTPConfigList.length > 0"
                        class="mt-3 table-striped"
                        :items="FTPConfigList"
                        :fields="FTPFields"
                        selectable select-mode="single" @row-selected="seeFTPConfigDetails">
                      </b-table>

                      <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-tab>
              </b-tabs>
            </b-row>
          </b-tab>

        </b-tabs>
        <b-row class="justify-content-end mt-3 no-gutters" v-if="configType !== 'INTERPROCESS' && canAddConfig">
          <app-button
            :text="$t('common.routing.add_config')"
            icon="fa-light fa-plus"
            variant="primary"
            @click="addConfig">
          </app-button>
        </b-row>
      </b-container>
    </template>
  </page-outline>

</template>

<script>

import Spinner from '@/components/common/spinner.vue'
import AppButton from '@/components/common/AppButton.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import PageOutline from "@/components/common/PageOutline.vue";

export default {
  name: 'ConfigurationList',
  components: {
    PageOutline,
    'app-button': AppButton,
    'spinner': Spinner
  },
  props: {
    type: {
      default: "WEBSERVICE"
    },
    role: {
      default: 1
    },
    entitiesType: {
      default: 'rvm'
    },
  },
  computed: {
    canAddConfig () {
      switch (this.configType) {
        case 'INTERPROCESS':
          return false
        case 'MQSERIES':
          return this.$engine.firstOn().rights.rightIs('mqseriesConfig_add', true)
        case 'REMOTEFOLDER':
          return this.$engine.firstOn().rights.rightIs('remoteFolderConfig_add', true)
        case 'WEBSERVICE':
          return this.$engine.firstOn().rights.rightIs('webServiceConfig_add', true)
        default:
          return false
      }
    },
    interProcessFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' }
      ]
    },
    mqseriesFields () {
      return [
        { key: 'idEngine', label: this.$t('common.alerts.engine'), class: 'text-center'},
        { key: 'Name', label: this.$t('common.routing.config_group_name'), class: 'text-center' },
        { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center' },
      ]
    },
    mqseriesCredentialFields () {
      return [
        { key: 'idEngine', label: this.$t('common.alerts.engine'), class: 'text-center'},
        { key: 'Name', label: this.$t('common.routing.config_group_name'), class: 'text-center' },
        { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center' },
      ]
    },
    remoteFolderFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Path', label: this.$t('common.routing.path'), class: 'text-center' }
      ]
    },
    FTPFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'Path', label: this.$t('common.routing.path'), class: 'text-center' }
      ]
    },
    webServiceConfigFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center text-truncate' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'URI', label: this.$t('common.routing.uri'), class: 'text-center text-truncate'},
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center text-truncate' },
        { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center text-truncate' }
      ]
    },
    webServiceCredentialFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center text-truncate' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center text-truncate' },
        { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center text-truncate' }
      ]
    }
  },
  data () {
    return {
      activateSpinner: false,
      configType: 'WEBSERVICE',
      interProcessConfigList: [],
      mqseriesConfigList: [],
      mqseriesCredentialList: [],
      FTPConfigList: [],
      FTPCredentialList: [],
      pageCounter: 0,
      returnUrl: '',
      entityType: 0,
      remoteFolderConfigList: [],
      tabName: 1,
      tabIndex: 0,
      webServiceConfigList: [],
      webServiceCredentialList: [],
    }
  },
  created () {
    if (this.type == 0 && this.role == 0 || this.type == 1 && this.role == 1) {
      this.tabName = this.role == "0" ? 0 : 1
      this.tabIndex = this.role == "0" ? 0 : 1
    }
    else{
      this.tabName = this.role == "0" ? 1 : 0
    }
    if (this.entitiesType == 'requester') {
      this.entityType = '0'
      this.returnUrl = '/entitiessettings/requester/Corporate'
    }
    if (this.entitiesType == 'responder') {
      this.entityType = '2'
      this.returnUrl = '/entitiessettings/responder/SI'
    }
    if (this.entitiesType == 'rvm') {
      this.entityType = '1'
      this.returnUrl = '/entitiessettings/rvm/BICRVM'
    }

    // if (this.type === "INTERPROCESS") {
    //   this.tabIndex = 0
    // } else if (this.type === "FTP") {
    //   this.tabIndex = 2
    // } else if (this.type === "MQSERIES") {
    //   this.tabIndex = 1
    // } else if (this.type === "REMOTEFOLDER") {
    //   this.tabIndex = 0
    // } else if (this.type === "WEBSERVICE") {
    //   this.tabIndex = 0
    // }

    // this.getConfigInterProcess()
    // this.getConfigRemoteFolder()
    // this.getConfigMQSeries()
    // this.getConfigFTP()
    // this.getConfigWebService()

    // this.$f7.initPullToRefresh()
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    role(newValue) {
      this.tabName = newValue == "1" ? 1 : 0
    },
  },
  methods: {
    addConfig () {
      let that = this
      if (this.configType === "MQSERIES") {
        loadPage(that, {url: '/routing/mqseriesConfigurationDetails/create'})
      } else if (this.configType === "REMOTEFOLDER") {
        loadPage(that, {url: '/routing/remoteFolderConfigurationDetails/create'})
      } else if (this.configType === "WEBSERVICE") {
        loadPage(that, {url: '/routing/webServiceConfigurationDetails/create'})
      }
    },
    canGetVopProvider () {
      return this.$engine.firstOn().rights.rightIs('vopProvider_consult', true)
    },
    generateUrlParams() {
      return '?role=' + this.role + '&type=' + this.type
    },
    getConfigInterProcess () {
      let that = this
      this.$engine.firstOn().routing.config.interProcess.fetch({

      }).then(resp => {
        let interProcessList = {}

        interProcessList = resp.data.InterProcesses

        this.updateInterProcess(interProcessList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getConfigMQSeries (index = 0) {
      let that = this
      if (index >= this.$engine.engines.length) {
        return
      }
      if (this.$engine.get(index).common.network.state === 'online') {
        this.$engine.get(index).routing.config.mqseries.fetch({
          entityType: that.entityType,
          Role: that.role
        })
        .then(resp => {
          let mqseriesList = {}

          mqseriesList = resp.data.MQSeriesConfig
          mqseriesList.forEach(mqseries=> {
            mqseries.idEngine = index
            if(mqseries.SSL === '1') {
              mqseries.SSLActive = that.$t('common.routing.yes')
            } else {
              mqseries.SSLActive = that.$t('common.routing.no')
            }
          })
          that.mqseriesConfigList = that.mqseriesConfigList.concat(mqseriesList)

          mqseriesList = {}

          mqseriesList = resp.data.MQSeriesCredential
          mqseriesList.forEach(mqseries=> {
            mqseries.idEngine = index
            if(mqseries.SSL === '1') {
              mqseries.SSLActive = that.$t('common.routing.yes')
            } else {
              mqseries.SSLActive = that.$t('common.routing.no')
            }
          })
          that.mqseriesCredentialList = that.mqseriesCredentialList.concat(mqseriesList)

          that.activateSpinner = false
          that.$f7.pullToRefreshDone()
        })
        .catch(err => {
          if (err.code === 'ERR_NETWORK') {
          } else {
            errorMessageAlert(err, that)
          }
        })
        .finally(() => {
          that.getConfigMQSeries(index + 1)
        })
      } else {
        that.getConfigMQSeries(index + 1)
      }
    },
    getConfigRemoteFolder () {
      let that = this
      this.$engine.firstOn().routing.config.remoteFolder.fetch({
      }).then(resp => {
        let remoteFolderList = {}

        remoteFolderList = resp.data.RemoteFolder

        this.updateRemoteFolders(remoteFolderList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getConfigFTP () {
      let that = this
      this.$engine.firstOn().routing.config.FTP.fetch({
        entityType: this.entityType,
        Role: this.role
      }).then(resp => {
        let FTPList = {}

        FTPList = resp.data

        this.updateFTP(FTPList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getConfigWebService () {
      let that = this
      this.$engine.firstOn().routing.config.webService.fetch({
        entityType: this.entityType,
        Role: this.role
      }).then(resp => {
        let webServiceList = {}

        webServiceList = resp.data

        this.updateWebServices(webServiceList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getVopProvider () {
      loadPage(this, {url: '/vopProvider/' + '?role=' + this.role})
    },
    onRefresh (index = 1) {
      this.activateSpinner = true
      this.pageCounter = 0

      // this.getConfigInterProcess()
      this.mqseriesConfigList = []
      this.mqseriesCredentialList = []
      this.getConfigMQSeries()
      // this.getConfigRemoteFolder()
      this.getConfigWebService()
      this.getConfigFTP()

      this.$f7.pullToRefreshDone()
    },
    seeMQSeriesDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.get(config.idEngine).routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesListConfig/'+config.idEngine+'/'+this.role+'/'+this.entitiesType+'/'+items[0].IdConfigRouting + this.generateUrlParams() })
    },
    seeMQSeriesCredentialDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.get(config.idEngine).routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesListConfig/'+config.idEngine+'/'+this.role+'/'+this.entitiesType+'/'+items[0].IdConfigRouting + this.generateUrlParams() })
    },
    seeRemoteFolderDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.firstOn().routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/remoteFolderConfigurationDetails/details/'+this.entitiesType})
    },
    seeFTPConfigDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.firstOn().routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/ftpConfigurationDetails/details/'+this.entitiesType + this.generateUrlParams() })
    },
    seeFTPCredentialDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.firstOn().routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/ftpCredentialDetails/details/'+this.entitiesType + this.generateUrlParams() })
    },
    seeWebServiceConfigDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.firstOn().routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/webServiceConfigurationDetails/details/'+this.entitiesType + this.generateUrlParams() })
    },
    seeWebServiceCredentialDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.firstOn().routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/webServiceCredentialDetails/details/'+this.entitiesType + this.generateUrlParams() })
    },
    updateInterProcess (interProcessList) {
      this.interProcessConfigList = interProcessList
    },
    updatemqseries (mqseriesList) {
      let that = this
      this.mqseriesConfigList = mqseriesList
      this.mqseriesConfigList.forEach(mqseries=> {
        if (mqseries.SSL === '1') {
          mqseries.SSLActive = that.$t('common.routing.yes')
        } else {
          mqseries.SSLActive = that.$t('common.routing.no')
        }
      })
    },
    updateRemoteFolders (remoteFolderList) {
      this.remoteFolderConfigList = remoteFolderList
    },
    updateFTP (FTPList) {
      this.FTPConfigList = FTPList.FTPConfig
      this.FTPCredentialList = FTPList.FTPCredential
    },
    updateWebServices (webServiceList) {
      let that = this
      this.webServiceCredentialList = webServiceList.WebServiceCredentials
      this.webServiceCredentialList.forEach(webService=> {
        if (webService.SSLMode !== "0") {
          webService.SSLActive = that.$t('common.routing.yes')
        } else {
          webService.SSLActive = that.$t('common.routing.no')
        }
      })
      this.webServiceConfigList = webServiceList.WebServiceConfig
      this.webServiceConfigList.forEach(webService=> {
        if (webService.SSLMode === "1") {
          webService.SSLActive = that.$t('common.routing.yes')
        } else {
          webService.SSLActive = that.$t('common.routing.no')
        }
      })
    }
  }
}
</script>
